export enum Status {
  Suspended = 2,
  Active = 1,
  Inactive = 0,
}
